import {
  GET_ALL,
  GET_ALL_FAILURE,
  GET_ALL_SUCCESS,
  ADD,
  ADD_FAILURE,
  ADD_SUCCESS,
  DELETE,
  DELETE_FAILURE,
  DELETE_SUCCESS,
  EDIT,
  EDIT_FAILURE,
  EDIT_SUCCESS,
  GET,
  GET_FAILURE,
  GET_SUCCESS,
} from "./actionTypes";

//actions types for Coupon

export const getAllCoupons = (payload) => {
  return {
    type: GET_ALL,
    payload: payload,
  };
};
export const getAllCouponsSuccess = (payload) => {
  return {
    type: GET_ALL_SUCCESS,
    payload: payload,
  };
};

export const getAllCouponsFailure = (error) => {
  return {
    type: GET_ALL_FAILURE,
    payload: error,
  };
};

export const addCoupon = (payload) => {
  return {
    type: ADD,
    payload: payload,
  };
};
export const addCouponSuccess = (payload) => {
  return {
    type: ADD_SUCCESS,
    payload: payload,
  };
};

export const addCouponFailure = (error) => {
  return {
    type: ADD_FAILURE,
    payload: error,
  };
};

export const getCoupon = (payload) => {
  return {
    type: GET,
    payload: payload,
  };
};
export const getCouponSuccess = (payload) => {
  return {
    type: GET_SUCCESS,
    payload: payload,
  };
};

export const getCouponFailure = (error) => {
  return {
    type: GET_FAILURE,
    payload: error,
  };
};

export const editCoupon = (payload) => {
  return {
    type: EDIT,
    payload: payload,
  };
};
export const editCouponSuccess = (payload) => {
  return {
    type: EDIT_SUCCESS,
    payload: payload,
  };
};

export const editCouponFailure = (error) => {
  return {
    type: EDIT_FAILURE,
    payload: error,
  };
};

export const deleteCoupon = (payload) => {
  return {
    type: DELETE,
    payload: payload,
  };
};

export const deleteCouponSuccess = (payload) => {
  return {
    type: DELETE_SUCCESS,
    payload: payload,
  };
};

export const deleteCouponFailure = (error) => {
  return {
    type: DELETE_FAILURE,
    payload: error,
  };
};
